
export enum OrgRoleType {
  User='User',
  DataSubmitter='DataSubmitter',
  Supervisor='Supervisor',
  Representative='Representative',
  Delete='Delete',
  None='None'
}
